/**
 * Helpers for reading the version metadata a lead's `designState` carries
 * (Round 1 f1-schema — mirrors DockPro-Backend's lib/lambda/utils/
 * designVersions.ts, the module the backend uses to project this same data
 * before a portal response goes out). `versions`/`currentVersionId` are
 * THIS REPO's own bolt-on fields, additive to the opaque core-owned
 * designState blob — reading just these two fields off it isn't the kind of
 * "inspecting dock geometry" this repo otherwise leaves to
 * @dockpro/core (see estimate.ts / lib/exports/*), so a small local reader
 * is appropriate here rather than routing through core.
 *
 * A lead's designState here already carries `versions` in its
 * METADATA-projected form (versionId/authorKind/createdAt/label only — see
 * api.ts's DesignVersionMetadata) whenever it comes from getLeadDetail;
 * that's the backend's job (portalLeadDetailHandler.ts), not this file's.
 *
 * A pre-migration lead's designState has no `versions`/`currentVersionId`
 * at all — every helper below treats that as "no versions yet," not an
 * error, same discipline as the backend mirror.
 */
import type { DesignVersionMetadata } from "./api";

export function getVersionMetadata(designState: unknown): DesignVersionMetadata[] {
  if (!designState || typeof designState !== "object") return [];
  const versions = (designState as Record<string, unknown>).versions;
  return Array.isArray(versions) ? (versions as DesignVersionMetadata[]) : [];
}

export function getCurrentVersionId(designState: unknown): string | undefined {
  if (!designState || typeof designState !== "object") return undefined;
  const currentVersionId = (designState as Record<string, unknown>).currentVersionId;
  return typeof currentVersionId === "string" ? currentVersionId : undefined;
}
